import { 
    getFirestore, 
    setDoc,
    doc,
    getDoc,
    Timestamp,
    // DocumentData,
} from 'firebase/firestore'

import firebase_app from '@/app/firebase/config'
import logger from '@/components/logger'

/** Matches `initialUserState.crawl_limit` in app/firebase/AuthContext.js */
export const DEFAULT_USER_CRAWL_LIMIT = {
    free_ai_overview: 0,
    ai_overview: 0,
    site_audit: 1500,
    free_site_audit: 10,
} as const

const getUserDoc = async ( 
    uid: string,
    displayName: string,
    email: string,
    photoURL: string,
    phoneNumber: string,
    attrs?: JSON
) => {
    try {
        if( uid ){
            const db = getFirestore(firebase_app)
            
            const docRef = doc( db, 'users', uid )
            const docSnap = await getDoc( docRef )

            if( docSnap.exists() ){
                await setDoc( docRef, {
                    last_login: Timestamp.fromDate( new Date() ),
                    display_name: displayName,
                    photo_url: photoURL,
                    phone_number: phoneNumber,
                    ...attrs
                }, { merge: true } )

                const docSnap = await getDoc( docRef )
                return docSnap.data()
            } else {
                
                await setDoc( docRef, {
                    created_time: Timestamp.fromDate( new Date() ),
                    last_login: Timestamp.fromDate( new Date() ),
                    email: email,
                    display_name: displayName,
                    photo_url: photoURL,
                    phone_number: phoneNumber,
                    uid: uid,
                    alpha_tester: true,
                    user_type: {
                        type: 'normal',
                        updated_time: Timestamp.fromDate( new Date() )
                    },
                    crawl_limit: { ...DEFAULT_USER_CRAWL_LIMIT },
                    ...attrs
                }, { merge: true } )
                const docSnap = await getDoc( docRef )
                return docSnap.data()
            }
        } else {
            throw Error('Missing uid')
        }
        
    } catch( err ){
        logger.error(err instanceof Error ? err : new Error(String(err)), 'getUserDoc error:', [], undefined)
        throw err
    }
}

export { getUserDoc }